import { makeOuiaAttributes } from './Ouia';
var useOuia = function (ouiaParams) {
    var type = ouiaParams.module !== undefined ? "".concat(ouiaParams.module, "/").concat(ouiaParams.type) : ouiaParams.type;
    return makeOuiaAttributes({
        fullType: type,
        ouiaId: ouiaParams.ouiaId,
        ouiaSafe: ouiaParams.ouiaSafe,
    });
};
export default useOuia;
//# sourceMappingURL=useOuia.js.map